// extracted by mini-css-extract-plugin
module.exports = {"number":"styles_number__29pKR","numberBoi":"styles_numberBoi__NRX1v"};